import { NUMBER_FORMAT } from './Const';

const currencyFormat = Intl.NumberFormat(NUMBER_FORMAT.JAPAN.CODE, {
  style: 'currency',
  currency: NUMBER_FORMAT.JAPAN.CURRENCY
});

export default currencyFormat;
